import { post, postFile, postExFile } from "@utils/httpUtil";

export function questionnaireDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/delete", data, config);
}

export function getCatalog(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/getCatalog", data, config);
}

export function getCreatorList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/getCreatorList", data, config);
}

export function getDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/getDetail", data, config);
}

export function getList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/getList", data, config);
}

export function getPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/getPage", data, config);
}

export function save(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/save", data, config);
}

export function importBaseAnswerItem(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postFile("/baseQuestionnaire/import/importBaseAnswerItem", data, config);
}

export function baseQuestionnaireItem(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postFile("/baseQuestionnaire/import/baseQuestionnaireItem", data, config);
}

export function exportErrorData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile("/baseQuestionnaire/export/errorData", data, config);
}

export function exportQuestionBank(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile("/baseQuestionnaire/export", data, config);
}
export function getQuestionCreateList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/getQuestionCreateList", data, config);
}
